const useWebinarDates = (scheduledAt) => {
  const today = new Date();
  const scheduledDate = new Date(scheduledAt);

  const dayAfterScheduled = new Date(scheduledDate);
  dayAfterScheduled.setDate(scheduledDate.getDate() + 1);

  const registrationCloseDate = new Date(scheduledDate);
  registrationCloseDate.setMinutes(scheduledDate.getMinutes() + 30);

  const isRegistrationClosed = registrationCloseDate < today;
  const isPastScheduledDate = scheduledDate < today;
  const isPastDayAfterScheduled = dayAfterScheduled < today;

  return {
    isRegistrationClosed,
    isPastScheduledDate,
    isPastDayAfterScheduled,
    scheduledDate,
    registrationCloseDate,
  };
};

export default useWebinarDates;
